// src/app/page.tsx
import { FC, useEffect, useState } from "react";
import { Chip, IconButton, Stack, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import DoneOutlineRoundedIcon from "@mui/icons-material/DoneOutlineRounded";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import "./index.css";
import AutomationsDrawer from "./Automations-drawer";

const Automations: FC = () => {
  const theme = useTheme();
  const [automationDrawerOpen, setAutomationDrawerOpen] = useState(false);

  const categoryChip = (text: string) => {
    return (
      <Chip
        className="category-check"
        color="secondary"
        sx={{ backgroundColor: theme.palette.background.default }}
        label={text}
        onDelete={() => console.log("chip")}
        deleteIcon={
          <DoneOutlineRoundedIcon
            sx={{
              color: "grey !important",
              fontSize: "15px !important",
            }}
          />
        }
      />
    );
  };

  return (
    <>
      <div className="automations-section">
        <Grid container sx={{ width: "100%" }}>
          <Grid size={{ xs: 4, md: 6 }}>
            <Typography component="div" sx={{ color: "grey" }}>Automations</Typography>
          </Grid>
          <Grid size={{ xs: 8, md: 6 }} display={"flex"} justifyContent={"end"}>
            <div className="memory-automations">
              <div>Manage automations </div>
              <div className="d-flex">
                {/* <img src={Memory} className="memory-img" /> */}
              </div>
            </div>
          </Grid>
        </Grid>
        <div className="automations-categories">
          <Typography component="div" color="secondary">
            <div className="category">
              <div className="category-name">
                Category 1 <div className="category-count">3</div>
              </div>
              <Stack direction={"row"} spacing={1}>
                {categoryChip("Send email")}
                {categoryChip("Post on social")}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    aria-label="more"
                    sx={{
                      backgroundColor: "grey",
                      borderRadius: "4px",
                      color: theme.palette.background.default,
                      padding: "0px 4px",
                      height: "20px",
                    }}
                    onClick={() => {
                      setAutomationDrawerOpen(true);
                    }}
                  >
                    <MoreHorizIcon />
                  </IconButton>
                </div>
              </Stack>
            </div>
            <div className="category">
              <div className="category-name">
                Category 2 <div className="category-count">1</div>
              </div>
              <Stack direction={"row"} spacing={2}>
                {categoryChip("Turn on AC")}
              </Stack>
            </div>
          </Typography>
        </div>
      </div>
      {automationDrawerOpen ? (
        <AutomationsDrawer
          openDrawer={true}
          setAutomationDrawerOpen={setAutomationDrawerOpen}
        />
      ) : null}
    </>
  );
};

export default Automations;
